/** @format */

import React, { Component } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Button,
  Divider,
  Box,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import { DecodificanString } from "../helpers/Codifican";
import { isMobile } from "react-device-detect";

const Comprobar = () => {
  window.location.reload();
};
const Login = () => {
  localStorage.clear();
  window.location.reload();
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      message: "",
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      message: error.message,
    });
  }

  render() {
    const DataLogin = JSON.parse(localStorage.getItem("LNTONE"));
    if (this.state.hasError) {
      return (
        <>
          {!isMobile ? (
            <Box
              my={15}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              <Card>
                <CardContent>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/static/imagen/algo-ha-salido-mal.png"
                    }
                    width="30%"
                    title="Imagen algo a salido mal"
                    alt="algo a salido mal"
                  ></img>
                  <br />
                  {DataLogin === null ? (
                    <>
                      <h1>Algo ha salido mal </h1> <p>Contacte al soporte</p>{" "}
                    </>
                  ) : (
                    <h1>Algo ha salido mal </h1>
                  )}
                  <Divider />
                  <p></p>
                  {/* <p>{this.state.message}</p> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={Comprobar}
                  >
                    REGRESAR AL MENÚ PRINCIPAL
                  </Button>{" "}
                  <br /> <br />
                  {DataLogin === null ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      disableElevation
                      onClick={Login}
                    >
                      {" "}
                      <PersonIcon /> REGRESAR AL LOGIN
                    </Button>
                  ) : (
                    ""
                  )}
                </CardContent>
              </Card>
            </Box>
          ) : (
            <Box
              my={15}
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50%",
              }}
            >
              <Card>
                <CardContent>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/static/imagen/algo-ha-salido-mal.png"
                    }
                    width="30%"
                    title="Imagen algo a salido mal"
                    alt="algo a salido mal"
                  ></img>
                  <br />
                  {DataLogin === null ? (
                    <>
                      <h1>Algo ha salido mal </h1> <p>Contacte al soporte</p>{" "}
                    </>
                  ) : (
                    <h1>Algo ha salido mal </h1>
                  )}
                  <Divider />
                  <p></p>
                  {/* <p>{this.state.message}</p> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={Comprobar}
                  >
                    REGRESAR AL MENÚ PRINCIPAL
                  </Button>{" "}
                  <br /> <br />
                  {DataLogin === null ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      disableElevation
                      onClick={Login}
                    >
                      {" "}
                      <PersonIcon /> REGRESAR AL LOGIN
                    </Button>
                  ) : (
                    ""
                  )}
                </CardContent>
              </Card>
            </Box>
          )}
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
